<template>
  <div class="container mt-xs-7 mt-sm-3 mt-md-2 mt-lg-1 mt-xl-1" v-if="isLoading">
    <div class="columns">
      <div class="column is-two-thirds">
        <span class="content">
          <img :src="essay.corrected_url" width="790" height="900" id="essay" alt="Redação corrigida" />
        </span>
        <div>
          <v-textarea
            label="Considerações finais"
            outlined
            :disabled="true"
            placeholder="Escreva..."
            v-model="essay.essay.comment"></v-textarea>
        </div>
      </div>
      <div class="column">
        <v-card>
          <div class="pa-2 inline">
            <v-card
              max-width="64"
              :key="index"
              :color="grade.skill.color"
              v-for="(grade, index) in essay.essay.grades_per_skill"
              :title="grade.skill.name"
            >
              <v-card-title
                class="white--text small--text"
                v-text="grade.grade"
              >
              </v-card-title>
            </v-card>
          </div>
          <v-card
            class="mx-auto mt-sm-3"
            max-width="344"
            outlined
            :key="index"
            :color="correct.color"
            v-for="(correct, index) in essay.corrections"
          >
            <v-card-title
              class="white--text"
              v-text="`${correct.counter} - ${correct.name}`"
            ></v-card-title>

            <v-card-text>
              <div class="headline white--text">
                {{correct.comment}}
              </div>
            </v-card-text>
          </v-card>
        </v-card>
      </div>
    </div>
  </div>
</template>

<script>
import EssayService from '@/services/essay/essay'
import notification from '@/support/mixins/notifications.mixin'

export default {
  name: 'Reviewer',
  mixins: [notification],
  data: () => ({
    EssayService: new EssayService(),
    essay: {},
    isLoading: false
  }),
  async mounted () {
    this.loadEssay()
  },
  methods: {
    async loadEssay () {
      try {
        this.isLoading = false
        const { data } = await this.EssayService.getCorrectedEssay(this.$route.params.id)
        this.essay = data
        console.log(this.essay)
      } catch (err) {
        console.log(err)
      } finally {
        this.isLoading = true
      }
    }
  }
}
</script>

<style scoped>
/* .column {
  border: 1px solid;
} */
.fa-2x {
  font-size: 1.5em;
}
.action {
  cursor: pointer;
  padding-right: 5px;
}
.div-p {
  background-color: #e0e9f2;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
}
.tools-div {
  margin-top: 1rem;
  margin-bottom: 1rem !important;
}

.markerjs-toolbar {
  position: absolute !important;
  left: 0 !important;
  top: 164.333px !important;
  right: 530px !important;
}

.pb-10 {
  padding-bottom: 10px;
}

.grade-container {
  border-bottom: 1px solid #9edbdf;
  border-right: 1px solid #9edbdf;
  border-left: 1px solid #9edbdf;
  border-bottom-left-radius: 5px;
  border-bottom-right-radius: 5px;
}

.grade {
  display: flex;
  flex: 1;
  flex-direction: column;
}

.inline {
  display: flex;
  width: 25vw;
  justify-content: space-around;
}

.small--text {
  font-size: 18px;
}

@media only screen and (max-width: 768px) {
  /* For mobile phones: */
  .inline {
    width: 100%;
  }
}
</style>
